import type { ProductItem } from '../hooks/useMemorialData';
import { ProductIcon } from '../lib/svg';

export const CAT_NAME: Record<string, string> = {
  cat_flower: '鲜花',
  cat_candle: '烛光',
  cat_incense: '清香',
  cat_food: '供品',
  cat_memory: '追思',
  cat_premium: '臻选',
};

/** 底部道具选择栏，所有模板共用 */
export default function PropBar({
  groups,
  activeCat,
  onSelectCat,
  onPick,
}: {
  groups: { categoryId: string; items: ProductItem[] }[];
  activeCat: string;
  onSelectCat: (id: string) => void;
  onPick: (product: ProductItem) => void;
}) {
  const items =
    groups.find((g) => g.categoryId === activeCat)?.items ?? groups.flatMap((g) => g.items);

  return (
    <div className="fixed inset-x-0 bottom-0 z-40 border-t border-[var(--c-border)] bg-[var(--c-surface)]/95 backdrop-blur">
      <div className="mx-auto max-w-5xl px-6 py-4">
        <div className="mb-3 flex gap-2 overflow-x-auto">
          {groups.map((g) => (
            <button
              key={g.categoryId}
              onClick={() => onSelectCat(g.categoryId)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-xs transition ${
                activeCat === g.categoryId
                  ? 'bg-[var(--c-text)] text-[var(--c-bg)]'
                  : 'bg-[var(--c-bg)] text-[var(--c-muted)]'
              }`}
            >
              {CAT_NAME[g.categoryId] ?? g.categoryId}
            </button>
          ))}
        </div>

        <div className="flex gap-3 overflow-x-auto pb-1">
          {items.map((p) => {
            const paid = p.tier === 'paid';
            return (
              <button
                key={p.id}
                onClick={() => onPick(p)}
                className={`relative flex min-w-[72px] flex-col items-center gap-1 rounded-xl border px-3 py-2.5 transition ${
                  paid
                    ? 'border-[var(--c-accent)]/50 bg-[var(--c-accent-soft)]'
                    : 'border-[var(--c-border)] bg-[var(--c-bg)]'
                }`}
              >
                {p.badgeText && (
                  <span className="absolute -right-1 -top-1 rounded-full bg-[var(--c-accent)] px-1.5 py-0.5 text-[9px] text-white">
                    {p.badgeText}
                  </span>
                )}
                <ProductIcon iconSvg={p.iconSvg} size={36} className="flex h-9 w-9 items-center justify-center" />
                <span className="whitespace-nowrap text-[11px] text-[var(--c-text)]">
                  {p.name}
                </span>
                <span
                  className={`text-[10px] ${paid ? 'font-medium text-[var(--c-accent)]' : 'text-[var(--c-muted)]'}`}
                >
                  {paid ? `$${(p.priceCents / 100).toFixed(2)}` : '免费'}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
